import {getApiUrl} from "../config";

export function getFileUrl (url) {
    if(!url) return;
    return `${getApiUrl()}api/file?url=${encodeURIComponent(url.split('/').slice(3).join('/'))}`
}

export function getHostname () {
    var items = window.location.hostname.split('.')
    if (items.length <= 3) {
        return window.location.hostname
    }
    return window.location.hostname.substring(window.location.hostname.indexOf('.') + 1)
}

export function getGenerateFormUrl (id) {
    return `${getApiUrl()}api/forms/generate/${id}`
}

export const getCurrentHost = () => {
    let location = window.location;
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
};


// WEBPACK FOOTER //
// ./src/utils/url.js